import { t } from "i18next";
import DBModal from "../../../../component/global/DBModal";
import DBSpinner from "../../../../component/global/DBSpinner";

export default function WaitModal({ show, onHide }) {
    return (
        <DBModal show={show} onHide={onHide} permanent className="wait-modal">
            <DBModal.Content>
                <DBSpinner />
                <div>{t("template.loading")}</div>
                <div>{t("template.loading.description")}</div>
            </DBModal.Content>
        </DBModal>
    );
}
